import axios from "axios";

import { ApiService } from "../../../servicios/api.service";

export class AuthApi {
    static endPoint = "auth/comercio/";

    static get BasePath() {
        return ApiService.api + this.endPoint;
    }

    static async logIn(email, password) {
        const response = await axios.post(this.BasePath + "login", {
            mail: email,
            clave: password
        });

        return response.data;
    }
}